import { isEmpty } from '@rainbow-modules/validation';

export const validateNotEmpty = (
    message: string,
) => (value: unknown) => {
    if (isEmpty(value)) return message;
    return undefined;
};
